import { IContrat, IFaturas, IContractResponse, IFaturasResponse } from './types';

export const MOCK_CENTRAL_CLIENTE_EMAILS = [
  'iredteste@partiu.com.br',
  'asdads@gmail.com', // Teste BrasRede (convênio 3248)
  'jpinfinity@gmail.com', // João Pedro — Adyl Vantagens (convênio 3249)
  'testesimmais2@partiu.com.br', // Teste Sim + 2 — Sim 2 (convênio 3264)
  'usertesterlvantagens@partiu.com.br', // User Teste Partiu — RL Vantagens (convênio 1266)
  'testedtelvantagens@partiu.com.br',
];

export function isMockCentralClienteEmail(email?: string | null): boolean {
  return MOCK_CENTRAL_CLIENTE_EMAILS.includes((email ?? '').trim().toLowerCase());
}

function pad2(value: number): string {
  return String(value).padStart(2, '0');
}

function formatDateBR(date: Date): string {
  return `${pad2(date.getDate())}/${pad2(date.getMonth() + 1)}/${date.getFullYear()}`;
}

const MOCK_CODIGO_CONTRATO = 999001;

export function buildMockContractResponse(page = 1): IContractResponse {
  const contrato: IContrat = {
    adesao: '15/01/2024',
    codigo_contrato: MOCK_CODIGO_CONTRATO,
    nome_contrato: 'Plano Fibra 500MB Residencial',
    nome_servico: 'Internet Fibra 500MB',
    valor_servico: '99.90',
    status_servico: 'Ativo',
    numero_contrato: 'MOCK-2024-000123',
    contrato_assinado: true,
    data_assinatura_contrato: '15/01/2024',
    data_contrato: '15/01/2024',
    observacao: 'Conta de testes — dados fictícios (Central do Cliente mock)',
    id_cliente_servico: MOCK_CODIGO_CONTRATO,
    link: null,
    produtos: ['Internet Fibra 500MB', 'Wi-Fi Mesh incluso', 'Suporte técnico prioritário'],
  };

  return {
    count: 1,
    next: null,
    previous: page > 1 ? 'https://mock.local/contratos/?page=1' : null,
    results: {
      result: true,
      status: 200,
      error: '',
      Contratos: page === 1 ? [contrato] : [],
    },
  };
}

export function buildMockFaturasResponse(page = 1): IFaturasResponse {
  const today = new Date();

  const faturas: IFaturas[] = [-3, -2, -1, 0, 1].map((offset) => {
    const vencimento = new Date(today.getFullYear(), today.getMonth() + offset, 10);
    return {
      codigo_fatura: 900000 + offset + 3,
      contrato: String(MOCK_CODIGO_CONTRATO),
      vencimento: formatDateBR(vencimento),
      descricao: 'Mensalidade Internet Fibra 500MB',
      fatura_paga: offset < 0,
      valor: '99.90',
      link_segunda_via: null,
      base64_segunda_via: '',
    };
  });

  return {
    count: faturas.length,
    next: null,
    status: 200,
    error: '',
    previous: page > 1 ? 'https://mock.local/faturas/?page=1' : null,
    results: {
      result: true,
      status: 200,
      error: '',
      Faturas: page === 1 ? faturas : [],
    },
  };
}
